import { render, staticRenderFns } from "./construction-grant.vue?vue&type=template&id=2d28f06a&"
import script from "./construction-grant.vue?vue&type=script&lang=js&"
export * from "./construction-grant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports